export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL ||
  "https://devapigw.bluex.cl/api/tracking/v2/backend";

export const API_KEY =
  process.env.REACT_APP_API_KEY || "r1VpTth1IHR4cQUm61WRylNXFOg25WDa";
